import { useEffect, useRef } from 'react';

/**
 * 获取组件目前的装载状态
 * @author Kody
 */
export const useIsMounted = (): {current: boolean} => {
    const isMountedRef = useRef(false);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    });
    return isMountedRef;
};
